import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpResponse, HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { MatDialog } from '@angular/material/dialog';
import { ErrorDialogComponent } from '../../sharedComponents/modal/modalComponents/error/error-dialog.component';
import { InformativeDialogComponent } from '../../sharedComponents/modal/modalComponents/informative/informative-dialog.component';
import { Router } from '@angular/router';
import {SessionTimer} from "../../sharedComponents/sessionTimer/sessionTimer";
// import {noUndefined} from "@angular/compiler/src/util";


@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  // Opened via MatDialog instead of ModalService: this interceptor can fire
  // while any MatDialog is open elsewhere in the app, and the legacy
  // ModalService popup would render behind it (see error-dialog.component.ts
  // for details).
  constructor(private dialog: MatDialog, private router: Router, private sessionTimer: SessionTimer, public http: HttpClient) {}
  // intercepts all HTTP requests, checks for error codes and displays a modal
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const token = sessionStorage.getItem('fileval');
    const modifiedReq = request.clone({
      headers: request.headers
        .set('X-Custom-Token', token || '')
        .set('X-App-Source', 'angular-client'),
    });
    return next.handle(modifiedReq).pipe(tap( (event: any) => {
      //Sorin - timeout code
      this.sessionTimer.restartTimer();
    }, (error: any) => {

      if (error.hasOwnProperty('status')) {
        if (error.status === 403) {
          let flag = sessionStorage.getItem("noAccessFlag");
          if (flag === null || flag === undefined) {
            // sessionStorage.setItem("noAccessFlag", "true");
            // sessionStorage.setItem("noAccessExpiration", String(new Date((new Date).getTime() + 30000).getTime()));
            // this.log403(JSON.stringify(error)).subscribe(data => {
            //   console.log(data);
            // });
            // location.reload();
          }
          else if (Boolean(flag) === true) {
            // sessionStorage.clear();
            // this.router.navigate(['/noAccess']);
            // let expString = sessionStorage.getItem("noAccessExpiration");
            // let exp = new Date(Number(expString));
            // let now = new Date();
            // if (now > exp) {
            //   sessionStorage.clear();
            //   this.router.navigate(['/noAccess']);
            // }
          }
          sessionStorage.clear();
          window.sessionStorage.setItem('gmlogoclick', 'false');
          this.router.navigate(['']);
        }
        //To handle too many requests
        else if (error.status === 406) {
          sessionStorage.clear();
          window.sessionStorage.setItem('gmlogoclick', 'true');
          window.sessionStorage.setItem('sesexpire', 'true');
          this.dialog.open(InformativeDialogComponent, {
            panelClass: 'app-informative-dialog-panel',
            data: { message: 'Due to increased security we would like you to confirm the Captcha and your GMIN. ' }
          }).afterClosed().subscribe(() => {
            this.router.navigate(['']);
          });
        }
        // To handle the token timeout
        else if (error.status === 400) {
          sessionStorage.clear();
          window.sessionStorage.setItem('gmlogoclick', 'true');
          window.sessionStorage.setItem('sesexpire', 'true');
          this.dialog.open(InformativeDialogComponent, {
            panelClass: 'app-informative-dialog-panel',
            data: { message: 'Due to increased security we would like you to confirm the Captcha and your GMIN. ' }
          }).afterClosed().subscribe(() => {
            this.router.navigate(['']);
          });
        }
        else  {
          if (error.status !== 403 && error.status !== 200) {
            sessionStorage.clear();
            window.sessionStorage.setItem('gmlogoclick', 'false');
            // this.router.navigate(['']);
            // if (error.status === 401) {
            //   sessionStorage.clear();
            //   window.sessionStorage.setItem('gmlogoclick', 'false');
            //   this.router.navigate(['']);
            // }
            this.dialog.open(ErrorDialogComponent, {
              panelClass: 'app-error-dialog-panel',
              data: { message: error.message }
            }).afterClosed().subscribe(() => {
              this.router.navigate(['']);
            });
          }
       }
     }
    }));
  }

  log403(data): any{
    return this.http.get(document.location.origin + '/logUser');
  }
}
